/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as LoginRouteImport } from './routes/login'
import { Route as IndexRouteImport } from './routes/index'
import { Route as TemplatesIndexRouteImport } from './routes/templates/index'
import { Route as StudentsIndexRouteImport } from './routes/students/index'
import { Route as SettingsIndexRouteImport } from './routes/settings/index'
import { Route as MessagesIndexRouteImport } from './routes/messages/index'
import { Route as LessonsIndexRouteImport } from './routes/lessons/index'
import { Route as JobsIndexRouteImport } from './routes/jobs/index'
import { Route as StudentsNewRouteImport } from './routes/students/new'
import { Route as StudentsIdRouteImport } from './routes/students/$id'
import { Route as LessonsNewRouteImport } from './routes/lessons/new'
import { Route as LessonsIdRouteImport } from './routes/lessons/$id'
import { Route as ConfirmTokenRouteImport } from './routes/confirm/$token'
import { Route as CaptureIdRouteImport } from './routes/capture/$id'

const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const TemplatesIndexRoute = TemplatesIndexRouteImport.update({
  id: '/templates/',
  path: '/templates/',
  getParentRoute: () => rootRouteImport,
} as any)
const StudentsIndexRoute = StudentsIndexRouteImport.update({
  id: '/students/',
  path: '/students/',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsIndexRoute = SettingsIndexRouteImport.update({
  id: '/settings/',
  path: '/settings/',
  getParentRoute: () => rootRouteImport,
} as any)
const MessagesIndexRoute = MessagesIndexRouteImport.update({
  id: '/messages/',
  path: '/messages/',
  getParentRoute: () => rootRouteImport,
} as any)
const LessonsIndexRoute = LessonsIndexRouteImport.update({
  id: '/lessons/',
  path: '/lessons/',
  getParentRoute: () => rootRouteImport,
} as any)
const JobsIndexRoute = JobsIndexRouteImport.update({
  id: '/jobs/',
  path: '/jobs/',
  getParentRoute: () => rootRouteImport,
} as any)
const StudentsNewRoute = StudentsNewRouteImport.update({
  id: '/students/new',
  path: '/students/new',
  getParentRoute: () => rootRouteImport,
} as any)
const StudentsIdRoute = StudentsIdRouteImport.update({
  id: '/students/$id',
  path: '/students/$id',
  getParentRoute: () => rootRouteImport,
} as any)
const LessonsNewRoute = LessonsNewRouteImport.update({
  id: '/lessons/new',
  path: '/lessons/new',
  getParentRoute: () => rootRouteImport,
} as any)
const LessonsIdRoute = LessonsIdRouteImport.update({
  id: '/lessons/$id',
  path: '/lessons/$id',
  getParentRoute: () => rootRouteImport,
} as any)
const ConfirmTokenRoute = ConfirmTokenRouteImport.update({
  id: '/confirm/$token',
  path: '/confirm/$token',
  getParentRoute: () => rootRouteImport,
} as any)
const CaptureIdRoute = CaptureIdRouteImport.update({
  id: '/capture/$id',
  path: '/capture/$id',
  getParentRoute: () => rootRouteImport,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/login': typeof LoginRoute
  '/capture/$id': typeof CaptureIdRoute
  '/confirm/$token': typeof ConfirmTokenRoute
  '/lessons/$id': typeof LessonsIdRoute
  '/lessons/new': typeof LessonsNewRoute
  '/students/$id': typeof StudentsIdRoute
  '/students/new': typeof StudentsNewRoute
  '/jobs/': typeof JobsIndexRoute
  '/lessons/': typeof LessonsIndexRoute
  '/messages/': typeof MessagesIndexRoute
  '/settings/': typeof SettingsIndexRoute
  '/students/': typeof StudentsIndexRoute
  '/templates/': typeof TemplatesIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/login': typeof LoginRoute
  '/capture/$id': typeof CaptureIdRoute
  '/confirm/$token': typeof ConfirmTokenRoute
  '/lessons/$id': typeof LessonsIdRoute
  '/lessons/new': typeof LessonsNewRoute
  '/students/$id': typeof StudentsIdRoute
  '/students/new': typeof StudentsNewRoute
  '/jobs': typeof JobsIndexRoute
  '/lessons': typeof LessonsIndexRoute
  '/messages': typeof MessagesIndexRoute
  '/settings': typeof SettingsIndexRoute
  '/students': typeof StudentsIndexRoute
  '/templates': typeof TemplatesIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/login': typeof LoginRoute
  '/capture/$id': typeof CaptureIdRoute
  '/confirm/$token': typeof ConfirmTokenRoute
  '/lessons/$id': typeof LessonsIdRoute
  '/lessons/new': typeof LessonsNewRoute
  '/students/$id': typeof StudentsIdRoute
  '/students/new': typeof StudentsNewRoute
  '/jobs/': typeof JobsIndexRoute
  '/lessons/': typeof LessonsIndexRoute
  '/messages/': typeof MessagesIndexRoute
  '/settings/': typeof SettingsIndexRoute
  '/students/': typeof StudentsIndexRoute
  '/templates/': typeof TemplatesIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/login'
    | '/capture/$id'
    | '/confirm/$token'
    | '/lessons/$id'
    | '/lessons/new'
    | '/students/$id'
    | '/students/new'
    | '/jobs/'
    | '/lessons/'
    | '/messages/'
    | '/settings/'
    | '/students/'
    | '/templates/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/login'
    | '/capture/$id'
    | '/confirm/$token'
    | '/lessons/$id'
    | '/lessons/new'
    | '/students/$id'
    | '/students/new'
    | '/jobs'
    | '/lessons'
    | '/messages'
    | '/settings'
    | '/students'
    | '/templates'
  id:
    | '__root__'
    | '/'
    | '/login'
    | '/capture/$id'
    | '/confirm/$token'
    | '/lessons/$id'
    | '/lessons/new'
    | '/students/$id'
    | '/students/new'
    | '/jobs/'
    | '/lessons/'
    | '/messages/'
    | '/settings/'
    | '/students/'
    | '/templates/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  LoginRoute: typeof LoginRoute
  CaptureIdRoute: typeof CaptureIdRoute
  ConfirmTokenRoute: typeof ConfirmTokenRoute
  LessonsIdRoute: typeof LessonsIdRoute
  LessonsNewRoute: typeof LessonsNewRoute
  StudentsIdRoute: typeof StudentsIdRoute
  StudentsNewRoute: typeof StudentsNewRoute
  JobsIndexRoute: typeof JobsIndexRoute
  LessonsIndexRoute: typeof LessonsIndexRoute
  MessagesIndexRoute: typeof MessagesIndexRoute
  SettingsIndexRoute: typeof SettingsIndexRoute
  StudentsIndexRoute: typeof StudentsIndexRoute
  TemplatesIndexRoute: typeof TemplatesIndexRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/templates/': {
      id: '/templates/'
      path: '/templates'
      fullPath: '/templates/'
      preLoaderRoute: typeof TemplatesIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/students/': {
      id: '/students/'
      path: '/students'
      fullPath: '/students/'
      preLoaderRoute: typeof StudentsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings/': {
      id: '/settings/'
      path: '/settings'
      fullPath: '/settings/'
      preLoaderRoute: typeof SettingsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/messages/': {
      id: '/messages/'
      path: '/messages'
      fullPath: '/messages/'
      preLoaderRoute: typeof MessagesIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/lessons/': {
      id: '/lessons/'
      path: '/lessons'
      fullPath: '/lessons/'
      preLoaderRoute: typeof LessonsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/jobs/': {
      id: '/jobs/'
      path: '/jobs'
      fullPath: '/jobs/'
      preLoaderRoute: typeof JobsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/students/new': {
      id: '/students/new'
      path: '/students/new'
      fullPath: '/students/new'
      preLoaderRoute: typeof StudentsNewRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/students/$id': {
      id: '/students/$id'
      path: '/students/$id'
      fullPath: '/students/$id'
      preLoaderRoute: typeof StudentsIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/lessons/new': {
      id: '/lessons/new'
      path: '/lessons/new'
      fullPath: '/lessons/new'
      preLoaderRoute: typeof LessonsNewRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/lessons/$id': {
      id: '/lessons/$id'
      path: '/lessons/$id'
      fullPath: '/lessons/$id'
      preLoaderRoute: typeof LessonsIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/confirm/$token': {
      id: '/confirm/$token'
      path: '/confirm/$token'
      fullPath: '/confirm/$token'
      preLoaderRoute: typeof ConfirmTokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/capture/$id': {
      id: '/capture/$id'
      path: '/capture/$id'
      fullPath: '/capture/$id'
      preLoaderRoute: typeof CaptureIdRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  LoginRoute: LoginRoute,
  CaptureIdRoute: CaptureIdRoute,
  ConfirmTokenRoute: ConfirmTokenRoute,
  LessonsIdRoute: LessonsIdRoute,
  LessonsNewRoute: LessonsNewRoute,
  StudentsIdRoute: StudentsIdRoute,
  StudentsNewRoute: StudentsNewRoute,
  JobsIndexRoute: JobsIndexRoute,
  LessonsIndexRoute: LessonsIndexRoute,
  MessagesIndexRoute: MessagesIndexRoute,
  SettingsIndexRoute: SettingsIndexRoute,
  StudentsIndexRoute: StudentsIndexRoute,
  TemplatesIndexRoute: TemplatesIndexRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
